import { API } from '@aws-amplify/api';

export type Subject = {
  subject: string;
};

export async function getSubjects(): Promise<Subject[]> {
  try {
    const apiName = process.env.NEXT_PUBLIC_DASH_API_NAME!;
    const path = 'get-ordered-coachbot-subjects';
    const response = await API.get(apiName, path, {});
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
